var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForbidLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3346C5.39746 18.3346 1.6665 14.6036 1.6665 10.0013C1.6665 5.39893 5.39746 1.66797 9.99984 1.66797C14.6022 1.66797 18.3332 5.39893 18.3332 10.0013C18.3332 14.6036 14.6022 18.3346 9.99984 18.3346ZM9.99984 16.668C13.6818 16.668 16.6665 13.6832 16.6665 10.0013C16.6665 6.3194 13.6818 3.33464 9.99984 3.33464C6.31794 3.33464 3.33317 6.3194 3.33317 10.0013C3.33317 13.6832 6.31794 16.668 9.99984 16.668ZM7.10245 5.92539L14.0758 12.8987C13.9163 13.1225 13.7362 13.3361 13.5353 13.5368C13.3346 13.7376 13.121 13.9177 12.8973 14.0772L5.92393 7.10391C6.08341 6.88013 6.26354 6.66654 6.4643 6.46577C6.66507 6.265 6.87866 6.08488 7.10245 5.92539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidLine);
export default __webpack_public_path__ + "static/media/forbid-line.cec5c406d30ea40906fc49d68bf6d437.svg";
export { ForwardRef as ReactComponent };